import React from 'react';
import SearchIcon from 'assets/Icons/topbar/SearchIcon';
import './searchBar.scss';
import { Box } from '@mui/material';

type SearchBarProps = {
  setGlobalFilter: any;
};

export default function SearchBar({ setGlobalFilter }: SearchBarProps) {
  return (
    <Box className="searchBar">
      <input
        className="search-input"
        type="search"
        placeholder="Search"
        onChange={(event) => setGlobalFilter(event.target.value)}
      />
      <button className="search-button">
        <SearchIcon />
      </button>
    </Box>
  );
}
